import React, {Component} from "react";
import PropTypes from "prop-types";
import {SingleDatePicker} from "react-dates";
import Moment from "moment";
import {_createNewEvent} from "../../../../../services/apis/EventServices";

class CreateNewEvent extends Component {
    state = {
        name: '',
        keyword: '',
        type: '',
        area: '',
        url: '',
        thumbnail: '',
        description: '',
        time: Moment(),
        timeFocused: false
    };

    _handleOnTimeFocused = (e) => {
        this.setState(({timeFocused}) => ({
            timeFocused: !timeFocused
        }));
    };

    _handleOnChangeDate = (time) => {

        this.setState({
            time,
        });
    };

    _handleChangeTextForm(field, e) {
        const {value} = e.target;

        this.setState({
            [field]: value
        });
    }

    _handleSubmit = (e) => {
        e.preventDefault();

        const timeFormat = 'DD/MM/YYYY';

        const {name, description, time, type, area, url, thumbnail, keyword} = this.state;

        _createNewEvent({
            name,
            description,
            time: time.format(timeFormat),
            type,
            area,
            url,
            keyword,
            thumbnail,
            gmt: time.utcOffset(),
            timeFormat
        }).then(result => {
            const {success, data, message} = result;

            if (success) {
                this.props.onCreated(data);
            } else {
                alert(message);
            }
        });
    };

    render() {
        const {name, description, timeFocused, type, area, url, keyword, time, thumbnail} = this.state;

        return (
            <div className="CreateNewEvent">
                <form onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'name')}
                            className="form-control" value={name}
                            name="name" type="text" placeholder="Name"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'keyword')}
                            className="form-control"
                            value={keyword} name="keyword"
                            type="text" placeholder="Keyword"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'thumbnail')}
                            className="form-control" value={thumbnail} name="thumbnail" type="text"
                            placeholder="Thumbnail URL"/>
                    </div>

                    <div className="form-group">
                        <textarea
                            placeholder="Description"
                            onChange={this._handleChangeTextForm.bind(this, 'description')}
                            value={description} className="form-control" name="description" rows="3"/>
                    </div>

                    <div className="form-group">
                        <SingleDatePicker
                            isOutsideRange={() => false}
                            date={time}
                            focused={timeFocused}
                            onFocusChange={this._handleOnTimeFocused}
                            onDateChange={this._handleOnChangeDate}/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'type')}
                            className="form-control" value={type}
                            name="type" type="text" placeholder="Type"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'area')}
                            className="form-control" value={area}
                            name="area" type="text" placeholder="Area"/>
                    </div>

                    <div className="form-group">
                        <input
                            onChange={this._handleChangeTextForm.bind(this, 'url')}
                            className="form-control" value={url}
                            name="url" type="url" placeholder="URL"/>
                    </div>

                    <div className="form-group">
                        <button className="btn btn-primary" type="submit">Create</button>
                    </div>
                </form>
            </div>
        );
    }
}

CreateNewEvent.propTypes = {
    onCreated: PropTypes.func.isRequired
};

export default CreateNewEvent;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventsPage/CreateNewEvent.js